module.exports = __webpack_public_path__ + "resources/message-delivered-fbc54350f74f5006e4e08a5de2547d31.svg";